<template>
	<Layout>
		<div class="directory-container">
			<div class="container">
				<div class="navbar-group justify-space-between flex-wrap gap-2 pt-3">
					<v-tabs v-model="directoryNav.activeTab" grow data-v-step="1">
						<v-tab value="teacher" data-cy="directory-nav-teacher" class="caps"
							>TEACHERS</v-tab
						>
						<v-tab value="parent" data-cy="directory-nav-parent" class="caps"
							>PARENTS</v-tab
						>
						<v-tab value="student" data-cy="directory-nav-student" class="caps"
							>STUDENTS</v-tab
						>
						<v-tab value="team" data-cy="directory-nav-team" class="caps">TEAMS</v-tab>
						<v-tab value="class" data-cy="directory-nav-class" class="caps"
							>CLASSES</v-tab
						>
					</v-tabs>
					<div style="flex-grow: 1; max-width: 100%; position: relative">
						<v-text-field
							style="width: 350px; max-width: 100%; margin-left: auto"
							class="custom-input"
							label="Search Directory"
							variant="outlined"
							bg-color="white"
							color="gray300"
							density="comfortable"
							v-model="directoryNav.search"
							append-inner-icon="mdi-magnify"
							clearable
						>
							<template #append>
								<v-menu
									location="bottom right"
									@update:model-value="directoryNav.setShowSelectionMenu($event)"
								>
									<template #activator="{ props }">
										<v-icon v-bind="props">mdi-menu-down</v-icon>
									</template>
									<v-list>
										<v-list-item
											color="primary"
											:active="directoryNav.deleted == false"
											:value="false"
											@click="directoryNav.setDeleted(false)"
											>Active Records</v-list-item
										>
										<v-list-item
											color="primary"
											:active="directoryNav.deleted == true"
											:value="true"
											@click="directoryNav.setDeleted(true)"
											>Archived Records</v-list-item
										>
									</v-list>
								</v-menu>
							</template>
						</v-text-field>
					</div>
				</div>

				<ParentsDirectory
					v-if="directoryNav.activeTab === 'parent'"
					:tab="directoryNav.activeTab"
					@update:tabs="directoryNav.setActiveTab($event)"
					:deleted="directoryNav.deleted"
					:search="directoryNav.search || ''"
					@update:search="directoryNav.setSearch($event)"
					:selected-entity="directoryNav.selectedEntity"
				>
				</ParentsDirectory>
				<TeachersDirectory
					v-if="directoryNav.activeTab === 'teacher'"
					:tab="directoryNav.activeTab"
					@update:tabs="directoryNav.setActiveTab($event)"
					:deleted="directoryNav.deleted"
					:search="directoryNav.search || ''"
					@update:search="directoryNav.setSearch($event)"
					:selected-entity="directoryNav.selectedEntity"
				></TeachersDirectory>
				<StudentsDirectory
					v-if="directoryNav.activeTab === 'student'"
					:tab="directoryNav.activeTab"
					@update:tabs="directoryNav.setActiveTab($event)"
					:deleted="directoryNav.deleted"
					:search="directoryNav.search || ''"
					@update:search="directoryNav.setSearch($event)"
					:selected-entity="directoryNav.selectedEntity"
				></StudentsDirectory>
				<TeamsDirectory
					v-if="directoryNav.activeTab === 'team'"
					:tab="directoryNav.activeTab"
					@update:tabs="directoryNav.setActiveTab($event)"
					:deleted="directoryNav.deleted"
					:search="directoryNav.search || ''"
					@update:search="directoryNav.setSearch($event)"
					:selected-entity="directoryNav.selectedEntity"
				></TeamsDirectory>
				<ClassesDirectory
					v-if="directoryNav.activeTab === 'class'"
					:tab="directoryNav.activeTab"
					@update:tabs="directoryNav.setActiveTab($event)"
					:deleted="directoryNav.deleted"
					:search="directoryNav.search || ''"
					@update:search="directoryNav.setSearch($event)"
					:selected-entity="directoryNav.selectedEntity"
				></ClassesDirectory>
			</div>
		</div>
	</Layout>
</template>

<script setup lang="ts">
import Layout from "./Layout.vue";
import useDirectoryNavigation from "@/stores/school/directoryNavigation";

import ParentsDirectory from "@/components/school/directory/parent/ParentsDirectory.vue";
import TeachersDirectory from "@/components/school/directory/teacher/TeachersDirectory.vue";
import StudentsDirectory from "@/components/school/directory/student/StudentsDirectory.vue";
import TeamsDirectory from "@/components/school/directory/team/TeamsDirectory.vue";
import ClassesDirectory from "@/components/school/directory/class/ClassesDirectory.vue";

// Use the directory navigation store
const directoryNav = useDirectoryNavigation();

</script>
